import React, { useEffect, useMemo, useState } from 'react'
import {
    Form,
    Button,
    Row,
    Col,
    Space,
    DatePicker,
    Switch,
    type DatePickerProps,
    Tooltip,
} from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import commonStyles from '../../../../../../Utils/Common.less'
import { useDispatch } from 'react-redux'
import partnerless from '../Partnershipserviceless.less'
import { type AnnualEditData } from '../../../../../../Types/Client/RegisteredClients/SoleTrader'
import moment from 'moment'
import dayjs from 'dayjs'
import { SaveAnualServices } from '../../../../../../Services/Individual'
import { getValidationRules } from '../../../../../../Utils/validatefiled'

const AnnualEditForm = (props: AnnualEditData): React.ReactElement => {
    const { editData, soletrderId, handleChildFormSave } = props
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [selectedDate, setSelectedDate] = useState<string | null>('')
    const [servicesEnabled, setServicesEnabled] = useState(false)
    const [buttonloading, setButtonLoading] = useState(false)
    useEffect(() => {
        if (editData !== null) {
            form.setFieldsValue(editData)
            const deadlineDate = moment(
                editData.fromDate,
                'MM/DD/YYYY h:mm:ss A'
            )
            const formattedDate = deadlineDate.format('MM/DD/YYYY')
            setSelectedDate(formattedDate)

            setServicesEnabled(editData.status === 'Active')
        }
    }, [editData])

    useEffect(() => {
        form.setFieldValue('fromDate', selectedDate)
    }, [selectedDate])

    const onChange = (
        deadlineDate: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (deadlineDate != null) {
            const isoDate = deadlineDate.toISOString()
            setSelectedDate(isoDate)
            form.setFieldValue('fromDate', isoDate)
            void form.validateFields(['fromDate'])
        } else {
            // If cleared, set empty values
            setSelectedDate(null)
            form.setFieldValue('fromDate', null)
        }
    }

    // const onRangePickerChange = (
    //     dates: any,
    //     dateStrings: [string, string]
    // ): void => {
    //     if (dates !== null) {
    //         const formattedDates = dates.map((date: moment.Moment) =>
    //             date.format('YYYY-MM-DD')
    //         )
    //         setPeriod(formattedDates)

    //         form.setFieldValue('period', formattedDates)
    //         void form.validateFields()
    //     } else {
    //         // If cleared, set empty values
    //         setPeriod([])
    //         form.setFieldValue('period', null)
    //     }
    // }

    const handleServiceSwitchChange = (checked: boolean): void => {
        setServicesEnabled(checked)
    }

    const handleSave = (): void => {
        void handleDataSave()
    }
    const handleDataSave = async (): Promise<void> => {
        try {
            await form.validateFields()
            const formdata = form.getFieldsValue()
            setButtonLoading(true)
            const dataToSave = {
                annualAccountId: editData.annualAccountId,
                companyType: 2,
                referenceId: soletrderId,
                fromDate:
                    selectedDate !== null
                        ? moment(formdata.fromDate).format('DD/MM/YYYY')
                        : '',
                toDate: null,
                deadlineDate: null,
                status: servicesEnabled ? 'Active' : 'Inactive',
            }

            const result = await SaveAnualServices(dispatch, dataToSave)

            if (result !== null && result !== undefined) {
                handleChildFormSave()
                setButtonLoading(false)
                setSelectedDate('')
            }
        } catch (error) {
            console.error('Error in handleDataSave:', error)
        }
    }
    console.log('selectedDate', selectedDate)
    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )
    const rules = useMemo(
        () => getValidationRules(servicesEnabled),
        [servicesEnabled]
    )

    return (
        <div className={commonStyles.formWrapper}>
            <Form
                form={form}
                name="ct-form"
                layout={'vertical'}
                autoComplete="off"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                requiredMark={customizeRequiredMark}
            >
                <Row gutter={16} className={partnerless.services}>
                    <Col span={12}>
                        {/* <Form.Item
                            label="Period"
                            name="period"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input Period!',
                                },
                            ]}
                            className={partnerless.datePicker}
                        >
                            <Space direction="vertical" size={12}>
                                <RangePicker
                                    className={partnerless.dateWidth}
                                    onChange={onRangePickerChange}
                                    value={
                                        period.length === 2 &&
                                        period[0] !== null &&
                                        period[1] !== null
                                            ? [
                                                  dayjs(period[0]),
                                                  dayjs(period[1]),
                                              ]
                                            : null
                                    }
                                    format={'DD/MM/YYYY'}
                                    allowClear={true}
                                />
                            </Space>
                        </Form.Item> */}
                        <Col span={12}>
                            <Form.Item
                                label="Start Date"
                                name="fromDate"
                                rules={rules.fromDate}
                                className={partnerless.datePicker}
                            >
                                <Space direction="vertical" size={12}>
                                    <DatePicker
                                        format="DD/MM/YYYY"
                                        className={partnerless.dateWidth}
                                        onChange={(date, dateString) => {
                                            onChange(date, dateString)
                                        }}
                                        value={
                                            selectedDate !== null
                                                ? dayjs(selectedDate)
                                                : null
                                        }
                                        allowClear
                                    />
                                </Space>
                            </Form.Item>
                        </Col>
                    </Col>
                    {/* <Col span={12}>
                        <Form.Item
                            label="Deadline Date"
                            name="deadlineDate"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input deadline date!',
                                },
                                {
                                    validator: async (_, value) => {
                                        if (period?.length !== 2) {
                                            await Promise.resolve()
                                            return
                                        }
                                        await validateDate(value)
                                        // const start = dayjs(period[0])
                                        const end = dayjs(period[1])
                                        const deadline = dayjs(value)

                                        if (
                                            deadline?.isBefore(end) ||
                                            end === deadline
                                        ) {
                                            return await Promise.reject(
                                                new Error(
                                                    'Deadline Date must be after both Period Start and End Dates!'
                                                )
                                            )
                                        }
                                        await Promise.resolve()
                                    },
                                },
                            ]}
                            className={partnerless.datePicker}
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    format="DD/MM/YYYY"
                                    className={partnerless.dateWidth}
                                    onChange={(date, dateString) => {
                                        onChange(date, dateString)
                                    }}
                                    value={
                                        selectedDate.length > 0
                                            ? dayjs(selectedDate)
                                            : null
                                    }
                                    allowClear
                                />
                            </Space>
                        </Form.Item>
                    </Col> */}
                </Row>
                <Row gutter={24} className={partnerless.services}>
                    <Col span={12}>
                        <Form.Item
                            label="Enable/Disable Services"
                            name="status"
                            labelCol={{ span: 16 }}
                            wrapperCol={{ span: 8 }}
                        >
                            <Switch
                                onChange={handleServiceSwitchChange}
                                checked={servicesEnabled}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col offset={21} span={2}>
                        <Tooltip title="Save Details">
                            <Button
                                type="primary"
                                onClick={handleSave}
                                loading={buttonloading}
                            >
                                <SaveOutlined />
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default AnnualEditForm
